// style
export const iconSize = {
	md: 'w-6 h-5 text-gray-500 svg-Fill m-auto self-center ml-2',
	lg: '',
}
